import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useProcessing } from '../../contexts/ProcessingContext';
import { useBrandKit } from '../../contexts/BrandKitContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLoader, FiCheck } = FiIcons;

export default function ProcessingStatus() {
  const { 
    uploadedFiles, 
    setProcessedFiles, 
    setCurrentStep, 
    progress, 
    setProgress 
  } = useProcessing();
  const { currentBrandKit } = useBrandKit();

  useEffect(() => {
    // Simulate processing
    const processFiles = async () => {
      const totalFiles = uploadedFiles.length;
      const processedFiles = [];

      for (let i = 0; i < totalFiles; i++) {
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        const file = uploadedFiles[i];
        processedFiles.push({
          ...file,
          processed: true,
          brandKit: currentBrandKit?.name || 'Default',
          processedAt: new Date().toISOString()
        });

        setProgress(((i + 1) / totalFiles) * 100);
      }

      setProcessedFiles(processedFiles);
      setTimeout(() => {
        setCurrentStep('results');
      }, 1000);
    };

    processFiles();
  }, [uploadedFiles, currentBrandKit, setProcessedFiles, setProgress, setCurrentStep]);

  return (
    <div className="bg-white rounded-lg shadow-md p-8">
      <div className="text-center">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          className="inline-block mb-6"
        >
          <SafeIcon icon={FiLoader} className="w-16 h-16 text-blue-600" />
        </motion.div>

        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          Processing Your Documents
        </h2>
        
        <p className="text-gray-600 mb-8">
          Applying brand styling and transformations...
        </p>

        <div className="max-w-md mx-auto">
          <div className="flex justify-between text-sm text-gray-600 mb-2">
            <span>Progress</span>
            <span>{Math.round(progress)}%</span>
          </div>
          
          <div className="w-full bg-gray-200 rounded-full h-2">
            <motion.div
              className="bg-blue-600 h-2 rounded-full"
              initial={{ width: 0 }}
              animate={{ width: `${progress}%` }}
              transition={{ duration: 0.5 }}
            />
          </div>
        </div>

        <div className="mt-8 space-y-3">
          {uploadedFiles.map((file, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0.5 }}
              animate={{ opacity: progress > (index / uploadedFiles.length) * 100 ? 1 : 0.5 }}
              className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
            >
              <span className="text-gray-900">{file.name}</span>
              {progress > (index / uploadedFiles.length) * 100 && (
                <SafeIcon icon={FiCheck} className="w-5 h-5 text-green-600" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}